export default "__VITE_ASSET__C33vdHsY__"